import { PixelPlaceholderLoader } from "@similarweb/ui-components";
import { Flex } from "@similarweb/ui-components/foundations";

import { generateAutomationName } from "app/pages/activation/helpers/generateAutomationName";

import { INSIGHT_ROW_SKELETON_PLACEHOLDERS } from "./insightsLoading.constants";
import * as SC from "./styles";

type InsightRowSkeletonProps = {
    index: number;
};

export const InsightRowSkeleton = ({ index }: InsightRowSkeletonProps) => {
    const { primary, tag, trailing } = INSIGHT_ROW_SKELETON_PLACEHOLDERS;

    return (
        <SC.InsightLoadingRowCard
            data-automation={generateAutomationName("home", ["insights", "row-skeleton", String(index)])}
            gap="12px"
        >
            <Flex
                alignItems="center"
                flex="1"
                gap="12px"
                minWidth={0}
            >
                <PixelPlaceholderLoader
                    height={primary.height}
                    width={primary.width}
                />
                <PixelPlaceholderLoader
                    borderRadius={tag.borderRadius}
                    height={tag.height}
                    width={tag.width}
                />
            </Flex>

            <PixelPlaceholderLoader
                borderRadius={trailing.borderRadius}
                height={trailing.height}
                width={trailing.width}
            />
        </SC.InsightLoadingRowCard>
    );
};
